<script>
import { VExpansionPanels } from 'vuetify/lib';
export default VExpansionPanels;
</script>
